import './App.css';
// import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import React, {useState} from 'react'
import Alert from './components/Alert';


function App() {
  const [mode, setmode] = useState('light')
  const [alert, setAlert] = useState(null)

  const showAlert =(message,type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{
      setAlert(null);
    },1500)
  }
  const toggleMode =()=>{
    if(mode === 'light'){
      setmode('dark');

      document.body.style.backgroundColor ='#434B51';
      showAlert("Dark mode have been enabled","success");
      // document.title= "TextUtiles -Dark Mode";
    }
    else{
      setmode('light');
      document.body.style.backgroundColor ='white';
      showAlert("Light mode have been enabled","success");
      // document.title= "TextUtiles -Light Mode";
    }
  }
  return (
    <>
    <Navbar title="TextUtils" aboutText="About Us" mode={mode} toggleMode={toggleMode} />
    <Alert alert ={alert}/>
    <div className="container my-3">
    <TextForm showAlert={showAlert} heading="Enter your text to: Convert to uppercase, Convert to lowercase, remove xtra space, copy text" mode={mode}/>
    </div>
    </>
  );
}

export default App;
